import { Box, IconButton, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

export const StyledWrapper = styled(Box)(({ theme }) => ({
  background: theme.palette.bg.secondary,
  borderRadius: '8px',
  width: '100%',
  padding: theme.spacing(2),
  border: '1px solid rgba(255,255,255,0.15)',
  position: 'relative',
  [theme.breakpoints.down('lg')]: {
    marginTop: theme.spacing(2),
  },
}));
export const WinListSkeleton = styled(Skeleton)(({ theme }) => ({
  background: theme.palette.bg.secondary,
  borderRadius: '8px',
  width: '100%',
  padding: theme.spacing(2),
  border: '1px solid rgba(255,255,255,0.15)',
  position: 'relative',
  [theme.breakpoints.down('lg')]: {
    marginTop: theme.spacing(2),
  },
}));
export const PrizeSkeleton = styled(Skeleton)(({ theme }) => ({
  width: '100%',
  height: '100%',
  background: '#16161B',
}));
export const StyledHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2),
  fontSize: '14px',
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    paddingLeft: 0,
    paddingRight: 0,
    marginBottom: theme.spacing(2),
  },
}));

export const StyledContent = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {},
}));
export const StyledArrowBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(2),
  top: theme.spacing(2),
  opacity: 0.3,
  cursor: 'pointer',
}));
export const StyledLeftArrow = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: theme.spacing(2),
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  zIndex: 100,
  [theme.breakpoints.down('md')]: {
    left: theme.spacing(1),
  },
}));
export const StyledRightArrow = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(2),
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  zIndex: 100,
  [theme.breakpoints.down('md')]: {
    right: theme.spacing(1),
  },
}));
export const ArrowIcon = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
  borderRadius: '8px',
  background: 'rgba(44, 44, 53, 0.50)',
}));

export const StyledSwiper = styled(Swiper)(({ theme }) => ({
  height: '179px',
  // [theme.breakpoints.down('md')]: {
  //   height: '64px',
  // },
}));
export const StyledSwiperSlide = styled(SwiperSlide)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  background: '#16161B',
  borderRadius: '8px',
  border: theme.palette.border.normal,
  padding: '12px',
  position: 'relative',

  // backgroundImage: `url('/assets/images/casino/rush-game/result-frame.png')`,
  //   backgroundRepeat: 'no-repeat',
  //   backgroundSize: '100% 100%',
  '&.swiper-slide': {
    display: 'flex',
  },
  '& .MuiTypography-root': {
    fontSize: '12px',
    color: 'rgba(255,255,255,0.75)',
    whiteSpace: 'nowrap',
  },
  '& span': {
    fontSize: '12px',
    whiteSpace: 'nowrap',
  },

  [theme.breakpoints.down('md')]: {
    fontSize: '11px',
    borderRadius: '2px',
    '& .MuiTypography-root': {
      fontSize: '12px',
    },
  },
}));
export const UnitBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  background: theme.palette.primary.main,
  right: '22px',
  top: '38px',
  borderRadius: '8px',
  padding: theme.spacing(0, 1),
  fontSize: '12px',
  color: '#0D0D0F',
  fontWeight: 600,
}));
